/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { VisitPackageMoveDto } from '../model';
/**
 * VisitPackageControllerApi - axios parameter creator
 * @export
 */
export const VisitPackageControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} visitPackageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackageVisitsToChange: async (visitPackageId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitPackageId' is not null or undefined
            assertParamExists('getPackageVisitsToChange', 'visitPackageId', visitPackageId)
            const localVarPath = `/api/visit-package/{visitPackageId}`
                .replace(`{${"visitPackageId"}}`, encodeURIComponent(String(visitPackageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VisitPackageControllerApi - functional programming interface
 * @export
 */
export const VisitPackageControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VisitPackageControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} visitPackageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPackageVisitsToChange(visitPackageId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<VisitPackageMoveDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPackageVisitsToChange(visitPackageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VisitPackageControllerApi - factory interface
 * @export
 */
export const VisitPackageControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VisitPackageControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} visitPackageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackageVisitsToChange(visitPackageId: number, options?: any): Promise<VisitPackageMoveDto> {
            return localVarFp.getPackageVisitsToChange(visitPackageId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VisitPackageControllerApi - object-oriented interface
 * @export
 * @class VisitPackageControllerApi
 * @extends {BaseAPI}
 */
export class VisitPackageControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} visitPackageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPackageControllerApi
     */
    public getPackageVisitsToChange(visitPackageId: number, options?: AxiosRequestConfig) {
        return VisitPackageControllerApiFp(this.configuration).getPackageVisitsToChange(visitPackageId, options).then((request) => request(this.axios, this.basePath));
    }
}
